import { VStack } from '@cbhq/cds-web/layout';
import { Link, TextTitle3, TextTitle4 } from '@cbhq/cds-web/typography';

import { BuildQuestModal } from ':cloud/widgets/buildQuest/BuildQuestModal';

interface ClaimPrizeModalProps {
  claimPrizeModalOff: () => void;
}

export function ClaimPrizeModal({ claimPrizeModalOff }: ClaimPrizeModalProps): JSX.Element {
  return (
    <BuildQuestModal onRequestClose={claimPrizeModalOff} visible>
      <VStack
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        spacingHorizontal={3}
        spacingBottom={6}
        gap={6}
      >
        <TextTitle3 as="p" align="center">
          Come show us what you&apos;ve worked on to claim your prize!
        </TextTitle3>
        <TextTitle4 as="p" align="center">
          We&apos;ll see you at{' '}
          <Link
            variant="title4"
            openInNewWindow
            to="https://www.google.com/maps/place/APT+101/@13.7382205,100.5590251,17z/data=!3m1!4b1!4m6!3m5!1s0x30e29f23ed3242df:0xa24ceccd198e1e52!8m2!3d13.7382205!4d100.5590251!16s%2Fg%2F11y7tdmq_v?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D"
            accessibilityLabel="Quest prize rules and terms"
          >
            APT 101
          </Link>{' '}
          on the 3rd floor.
        </TextTitle4>
      </VStack>
    </BuildQuestModal>
  );
}
